import { z } from "zod";
import { UserRole, CustomerAccessEnum } from "../dto";
import { phoneRegex } from "../../../lib/regex";

export const updateUserSchema = z.object({
    name: z.string().min(1, "Il nome è obbligatorio"),
    surname: z.string().min(1, "Il cognome è obbligatorio"),
    collaborators: z.array(z.string()).optional(),
    customerId: z.string().optional().nullable(),
    phone: z.string().optional().nullable(),
    isAutonomous: z.boolean().optional().nullable(),
    companyName: z.string().optional().nullable(),
    companyVat: z.string().optional().nullable(),
    companyAtecoCode: z.string().optional().nullable(),
    companySector: z.string().optional().nullable(),
    companyRevenue: z.number().optional().nullable(),
    companyWebsite: z.string().optional().nullable(),
    customerAccess: z.string().refine(val => Object.values(CustomerAccessEnum).includes(val as CustomerAccessEnum), { message: "Selezionare un accesso cliente" }).nullable().optional(),
}).superRefine((data, ctx) => {
    if (data.phone && !phoneRegex.test(data.phone)) {
        ctx.addIssue({
            code: "custom",
            path: ["phone"],
            message: "Numero di telefono non valido",
        });
    }

    if (data.companyVat && (data.companyVat.length < 11 || data.companyVat.length > 16)) {
        ctx.addIssue({
            code: "custom",
            path: ["companyVat"],
            message: "Partita IVA non valida",
        });
    }
});

export const roleUpdateSchema = z.object({
    role: z.string().refine(val => Object.values(UserRole).includes(val as UserRole), { message: "Selezionare un ruolo" }),
    teamLeaderId: z.string().optional(),
}).superRefine((data, ctx) => {
    if (
        data.role === UserRole.team_leader &&
        data.teamLeaderId === undefined
    ) {
        ctx.addIssue({
            code: "custom",
            path: ["teamLeaderId"],
            message: "Team leader richiesto per il nuovo ruolo",
        });
    }
});

export const rolesMap = new Map<UserRole, UserRole[]>([
    [UserRole.admin, [UserRole.admin]],
    [UserRole.collaborator, [UserRole.collaborator]],
    [UserRole.commercial, [UserRole.commercial, UserRole.team_leader]],
    [UserRole.customer, [UserRole.customer]],
    [
        UserRole.team_leader,
        [UserRole.team_leader, UserRole.commercial, UserRole.admin],
    ],
]);
